import type { CSSProperties } from 'react';
import type { UseFormReturn } from 'react-hook-form';

import { FormProvider as RHFForm } from 'react-hook-form';

// ----------------------------------------------------------------------

export type FormProps = {
  onSubmit?: (event: React.FormEvent) => void;
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  style?: CSSProperties;
};

export function Form({ children, onSubmit, methods, style }: FormProps) {
  return (
    <RHFForm {...methods}>
      <form onSubmit={onSubmit} noValidate autoComplete="off" style={style}>
        {children}
      </form>
    </RHFForm>
  );
}
